import { fetchApi } from "../../utils/fetchApis";

export const baseUrl = import.meta.env.VITE_BASE_URL;

const loginURL = 'login/memberLogin'
const memberDetailURL = 'member/details'
const refreshTokenURL = 'token/refresh'

export async function doLogin(data) {
  return fetch(`${baseUrl}/${loginURL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Accept-Language': data.language,
    },
    body: JSON.stringify(data),
  }).then((response) =>
    response.json().then((data) => ({
      data: data,
      status: response.status,
    })).then((response) => {
      return response;
    })    
  ).catch((err) => {
    throw err;
  });
}

export async function getMemberDetails(accessToken) {
  const header = {
    accessToken
  }
  return fetchApi(memberDetailURL, 'GET', header);
}

export async function refreshToken(payload) {
  const header = {
   accessToken: payload.currentToken
  }
  return fetchApi(refreshTokenURL, 'POST', header, payload);
}

